class DetailsElement extends HTMLElement {
	constructor() {
		super();

		let title = document.querySelector("span[title]");
		title.classList.add("details--title");
		title.removeAttribute("title");

		this.content = document.querySelector("div[content]");
		this.content.classList.add("details--content");
		this.content.removeAttribute("content");

		let toggle = document.createElement("span");
		toggle.classList.add("details--toggle");

		this.root = document.createElement("a");
		this.root.href = "javascript:;";
		this.root.classList.add("details--root");

		this.root.append(title, toggle);

		this.root.addEventListener("click", () => {
			this.expand.style.setProperty("--height", this.content.clientHeight + "px");
			this.classList.toggle("open");

			if (this.hasAttribute("scrollable")) {
				scrollAnimationState.begin(500, this);
			}
			else {
				console.warn("Details element is not scrollable, and can't animate scroll position.");
			}
		});

		this.expand = document.createElement("div");
		this.expand.classList.add("details--expand");

		this.expand.append(this.content);

		this.append(this.root, this.expand);
	}
}

customElements.define("san-details", DetailsElement);